<template>
  <div id="input-container" style="padding-bottom: 12px !important;">
    <v-layout align-center pa-3>
      <v-text-field v-model="code" label="Code"></v-text-field>
      <v-btn small class="black--text text-none rounded-button" @click="addPromocode">
        <div v-if="!loading">Add Promocode</div>
        <div style="margin-top: 10px;">
          <pulse-loader v-if="loading == true" :loading="loading" color="#330066"></pulse-loader>
        </div>
      </v-btn>
    </v-layout>
    <v-layout px-3>
      <p style="color: red">{{error}}</p>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";

import PulseLoader from "vue-spinner/src/PulseLoader.vue";

axios.defaults.withCredentials = true;

export default {
  name: "PromocodeInput",
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    name: String,
    content: String,
    bookingForm: Object
  },
  data: function() {
    return {
      loading: false,
      complete: false,
      code: "",
      error: null
    };
  },
  components: {
    PulseLoader
  },
  methods: {
    startLoading() {
      this.loading = true;
    },
    doneLoading() {
      this.loading = false;
    },
    submit() {
      document.getElementById("card-form").submit();
    },
    async addPromocode() {
      console.log("Submitting code " + this.code);

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/customer/addPromocodeByCode?code=${this.code}&number=${this.bookingForm.user.contact_number}&name=${this.bookingForm.user.name}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        if (response.data.error == "no_error") {
          this.bookingForm.user.promocodes.push(response.data.promocode_user);

          this.$emit("addedPromocode", response.data.promocode_user.id);

          return response.data.error;
        } else {
          this.error = response.data.error;
          return response.data.error;
        }
      } catch (error) {
        console.log(error);
        this.error = "Unknown Error";
        return "unknown_error";
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
